import { maintainersRoutes } from "./routes/maintainers.routes";
import { settingsRoutes } from "./routes/settings.routes";
import { purchaseRoutes } from "./routes/purchase.routes";
import { coreRoutes } from "./routes/core.routes";
import { reportRoutes } from "./routes/report.routes";
import { historiesRoutes } from "./routes/histories";

export const routes = [...maintainersRoutes, ...settingsRoutes, ...purchaseRoutes, ...coreRoutes, ...reportRoutes, ...historiesRoutes];
